export enum DossierBusinessStructureEnum {
    company = '1',
    soleTrader = '2',
    charity = '3',
    partnership = '4',
    llp = '5',
    other = '6'
}
